import * as React from 'react';
export const panelArrowLeftSvg = React.forwardRef(
  function panelArrowLeftSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M14.125 1c.483 0 .875.392.875.875v12.25a.875.875 0 0 1-1.75 0V1.875c0-.483.392-.875.875-.875Zm-6.899.867c.35.333.363.887.03 1.237L3.418 7.125h6.706a.875.875 0 0 1 0 1.75H3.487l3.754 3.757a.875.875 0 1 1-1.238 1.236L.756 8.618a.873.873 0 0 1-.014-1.222l5.247-5.5a.875.875 0 0 1 1.237-.03Z',
      }),
    );
  },
);
panelArrowLeftSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var panelArrowLeft = {
  category: 'icon',
  colorable: true,
  name: 'panelArrowLeft',
  svg: panelArrowLeftSvg,
};
